import HeaderSlider from '@features/voxbox/sections/Header/components/HeaderSlider/HeaderSlider';
import { IHeaderObject } from '@features/voxbox/typescript';
import styles from '@features/voxbox/sections/Header/components/HeaderSlider/HeaderSlider.styles';
import SliderItem from '@components/Slider/SliderItem';
type PropsType = {
  header: IHeaderObject;
};
const HeaderSection = ({
  header
}: PropsType) => <section sx={styles.sectionHeader} data-cy="HeaderSection">
    {header.slides.length > 1 ? <HeaderSlider slides={header.slides} /> : <SliderItem item={header.slides[0]} isActive isFirst />}
    <div sx={styles.frame} data-cy="HeaderSectionFrame">
      {header.frame}
    </div>
  </section>;
export default HeaderSection;